import { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { subscribeHttpTimeout } from "../utils/httpClient";

/**
 * Subscribes to global HTTP timeouts and shows an error dialog with the failed URL.
 */
export default function HttpTimeoutDialogHost() {
  const [open, setOpen] = useState(false);
  const [endpoint, setEndpoint] = useState("");

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    return subscribeHttpTimeout((url) => {
      setEndpoint(url);
      setOpen(true);
    });
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="http-timeout-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="http-timeout-dialog-title" color="error">
        Error
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          <Typography sx={{ mb: 1 }}>
            The request timed out after 10 seconds.
          </Typography>
          <Typography
            variant="body2"
            component="code"
            sx={{
              display: "block",
              wordBreak: "break-all",
              bgcolor: "action.hover",
              p: 1,
              borderRadius: 1,
            }}
          >
            {endpoint}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
